/**
 * InputSelect 组件的 API 调用和数据转换
 */

import { searchLocations as searchLocationsApi, searchHashtags as searchHashtagsApi } from '@/lib/service/dashboard';
import { LocationItem, HashtagItem, LocationApiItem, HashtagDetail } from './types';

/**
 * 搜索 Locations 并转换为组件格式
 */
export const searchLocation = async (query: string): Promise<LocationItem[]> => {
  if (!query.trim()) {
    return [];
  }

  try {
    const response = await searchLocationsApi(query);

    // 检查响应状态 (code: 0 表示成功)
    if (!response || response.code !== 0) {
      console.error('Location search failed:', response);
      return [];
    }

    // 转换 API 响应为组件所需的格式
    const results: LocationItem[] = (response.data || []).map((item: LocationApiItem) => {
      const location = item.location;
      return {
        id: location?.pk || '',
        name: item.title || location?.name || '',
        type: 'location' as const,
        detail: location,
      };
    });

    return results;
  } catch (error) {
    console.error('Error searching locations:', error);
    return [];
  }
};

/**
 * 搜索 Hashtags 并转换为组件格式
 */
export const searchHashtag = async (query: string): Promise<HashtagItem[]> => {
  if (!query.trim()) {
    return [];
  }

  try {
    const response = await searchHashtagsApi(query);

    // 检查响应状态 (code: 0 表示成功)
    if (!response || response.code !== 0) {
      console.error('Hashtag search failed:', response);
      return [];
    }

    // 转换 API 响应为组件所需的格式
    const results: HashtagItem[] = (response.data || []).map((item: HashtagDetail) => {
      return {
        id: item.id || item.challenge_id || '',
        name: item.name || '',
        postCount: item.search_result_subtitle || item.formatted_media_count || '',
        type: 'hashtag' as const,
        detail: item,
      };
    });

    return results;
  } catch (error) {
    console.error('Error searching hashtags:', error);
    return [];
  }
};
